/******************************************************************************
 * @Author                : Jbristhuille<jbristhuille@gmail.com>              *
 * @CreatedDate           : 2024-10-29 09:17:22                               *
 * @LastEditors           : Jbristhuille<jbristhuille@gmail.com>              *
 * @LastEditDate          : 2025-02-03 12:22:41                               *
 *****************************************************************************/

/* SUMMARY
  * NOTES
  * Environements variables
  * Get environements variables
*/

/* NOTES
  * Google Map API key is on index.html to avoid multiple loading
*/

/* Environements variables */
// NOTE: DIAG_SECU_API_BASE is the base URL of the *central* diag_secu admin API (non-realm-prefixed;
// request paths start with "/admin"). The exact gateway path prefix is pending the gateway route
// (see the plan's "Deferred to Implementation"): adjust the "/diag-secu" segment once it exists.
const envVar = {
  default: {
    GATEWAY_URL: "https://develop-easytech.chronolink.eu/gateway",
    KEYCLOAK_URL: "https://develop-easytech.chronolink.eu/sso",
    KC_CLIENT_ID: "easy_connect",
    DIAG_SECU_API_BASE: "https://develop-easytech.chronolink.eu/gateway/diag-secu",
    mode: import.meta.env.REACT_APP_MODE
  },
  local: {
    GATEWAY_URL: "http://localhost:9092/gateway",
    KEYCLOAK_URL: "https://develop-easytech.chronolink.eu/sso",
    KC_CLIENT_ID: "easy_connect",
    // Same-origin path proxied by the Vite dev server to the local diag backend (see vite.config.ts).
    // Avoids CORS: the diag Spring service sends no CORS headers, so direct cross-port calls are
    // rejected at the preflight. Override the target with DIAG_SECU_PROXY_TARGET if not on :8081.
    DIAG_SECU_API_BASE: "/diag-secu-api",
  },
  dev: {
    GATEWAY_URL: "https://develop-easytech.chronolink.eu/gateway",
    KEYCLOAK_URL: "https://develop-easytech.chronolink.eu/sso",
    KC_CLIENT_ID: "easy_connect",
    DIAG_SECU_API_BASE: "https://develop-easytech.chronolink.eu/gateway/diag-secu",
  },
  preprod: {
    GATEWAY_URL: "https://preprod-easytech.chronolink.eu/gateway",
    KEYCLOAK_URL: "https://preprod-easytech.chronolink.eu/sso",
    KC_CLIENT_ID: "easy_connect",
    DIAG_SECU_API_BASE: "https://preprod-easytech.chronolink.eu/gateway/diag-secu",
  },
  production: {
    GATEWAY_URL: "https://easytech.chronolink.eu/gateway",
    KEYCLOAK_URL: "https://easytech.chronolink.eu/sso",
    KC_CLIENT_ID: "easy_connect",
    DIAG_SECU_API_BASE: "https://easytech.chronolink.eu/gateway/diag-secu",
  }
};
/***/

/**
* Get environements variables
* @return - Environement variables
*/
const getEnv = () => {
  const mode: "dev" | "local" | "preprod" | "production" = import.meta.env.REACT_APP_MODE as "dev" | "local" | "preprod" | "production" ;
  return {...envVar.default, ...(mode ? envVar[mode] : {})};
};
/***/

export const env = getEnv();
